module.exports = __webpack_public_path__ + "static/img/chat-pass.f88879e4.png";